import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API } from '../utils/axiosConfig';

const ProtectedRoute = ({ children, userLevel = 'client' }) => {
	const api = API();
	const { isAuthenticated, setShowLogin, user, login, logout } = useAuth();

	useEffect(() => {
		if (!user && sessionStorage.getItem('user')) {
			//User is still in session, but not in context (page was refreshed)
			//Attempt to reload the user from the server
			api
				.get('/users/refreshUser')
				.then((res) => {
					if (res.status === 200) {
						login(res.data.user);
					}
				})
				.catch((err) => {
					console.log(err);
					logout();
				});
		}
		//If the user is not authenticated, send to home page with Login prompt
		if (!isAuthenticated()) setShowLogin(true);
	});

	useEffect(() => {
		if (user) {
			//If Protected Route is for Admin only
			if (userLevel === 'admin' && user.userLevel !== 'admin') {
				logout();
			}
		}
	}, [user]);

	return isAuthenticated() ? children : <Navigate to="/" />;
};
export default ProtectedRoute;
